import { State } from 'src/types'
import { webOfNormalPocket, webOfShallowPocket, webTop } from './web'

export const webDrawer = async (ctx: CanvasRenderingContext2D, state: State): Promise<void> => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = state.catchFace.color

  const isShallowWebModel = ['AKG-JS2'].includes(state.baseModel.productNumber)
  const printLeatherTypeValue = state.printLeatherType?.value

  if (isShallowWebModel) {
    await webOfShallowPocket(ctx, state.web.color, state.stitch.color, printLeatherTypeValue)
    await webTop(ctx, state.web.color, state.stitch.color, printLeatherTypeValue)
  }

  if (!isShallowWebModel) {
    await webOfNormalPocket(ctx, state.web.color, state.stitch.color, printLeatherTypeValue)
    await webTop(ctx, state.web.color, state.stitch.color, printLeatherTypeValue)
  }
}
